import axios from "axios";
import { get, put, post, del, getTimezone } from './connection'

// const API_URL = "http://talentrivers.com/TimeZone/api_departmentDetails_18_03_2025.php";
// const API_KEY = "1234";

const apiService = {
getActiveUsers: async () => {  
    try {
      const response = await get("/api/get-active-users");
      return response.data;
    } catch (error) {
        throw new Error("Error while fetching user details");
    }
},
getActiveDepartments: async () => {
  try {
    const response = await get("/api/get-all-department");
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching departments details");
  }
},
getActiveDesignations: async () => {
  try {
    const response = await get("/api/get-active-designations");
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching designations details");
  }
},
getActiveCompanies: async () => {
  try {
    const response = await get("/api/get-all-company");
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching companies details");
  }
},
getAllCountry: async () => {
  try {
    const response = await get("/api/get-all-country");
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching country details");
  }
},
getStatesByCountryId: async (countryId) => {
  try {
    const response = await get(`/api/get-state-by-country-id/${countryId}`);;
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching state details");
  }
},
getActiveAccounts: async () => {
  try {
    const response = await get("/api/get-all-accounts");
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching accounts list");
  }
},

getClientAccountManagerLst: async () => {
  try {
    const response = await get("/api/get-client-account-manager-list");
    return response.data;
  } catch (error) {
      throw new Error("Error while fetching account manager list");
  }
},

};

export default apiService;
